module.exports = __webpack_public_path__ + "static/media/C5.b751f87.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C5.mp4
// module id = O0Eq
// module chunks = 8